import { render } from "./region-attachment.vue?vue&type=template&id=0e4714ea"
import script from "./region-attachment.vue?vue&type=script&lang=js"
export * from "./region-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__